import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#000000',
                secondary:'#6bb300',
                error: '#8b0000',
                success: '#006400',
            },
        },
    }

});
